import { fmtCurrency } from '../../../utils/formatNumber';
import styles from '../Reports.module.css';

const FundTable = ({ rows, tfoot }) => (
  <div className="table-container">
    <table>
      <thead>
        <tr>
          <th>Category</th>
          <th className={styles.amtRight}>Opening (₹)</th>
          <th className={styles.amtRight}>Income (₹)</th>
          <th className={styles.amtRight}>Expense (₹)</th>
          <th className={styles.amtRight}>Closing (₹)</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>
            <td>{r.category}</td>
            <td className={styles.amtRight}>{fmtCurrency(r.openingBalance)}</td>
            <td className={`${styles.amtRight} ${styles.balanceOk}`}>{fmtCurrency(r.income)}</td>
            <td className={`${styles.amtRight} ${styles.balanceDiff}`}>{fmtCurrency(r.expense)}</td>
            <td className={styles.amtRight}><strong>{fmtCurrency(r.closingBalance)}</strong></td>
          </tr>
        ))}
      </tbody>
      {tfoot && (
        <tfoot>
          <tr>
            <td><strong>{tfoot.label}</strong></td>
            <td className={styles.amtRight}><strong>{fmtCurrency(tfoot.openingBalance)}</strong></td>
            <td className={`${styles.amtRight} ${styles.balanceOk}`}><strong>{fmtCurrency(tfoot.income)}</strong></td>
            <td className={`${styles.amtRight} ${styles.balanceDiff}`}><strong>{fmtCurrency(tfoot.expense)}</strong></td>
            <td className={styles.amtRight}><strong>{fmtCurrency(tfoot.closingBalance)}</strong></td>
          </tr>
        </tfoot>
      )}
    </table>
  </div>
);

export default function CategoryFundReport({ data }) {
  if (!data) return null;

  const { categories = [], commission } = data;

  const catTotals = categories.reduce(
    (acc, r) => ({
      openingBalance: acc.openingBalance + (r.openingBalance || 0),
      income:         acc.income         + (r.income         || 0),
      expense:        acc.expense        + (r.expense        || 0),
      closingBalance: acc.closingBalance + (r.closingBalance  || 0),
    }),
    { openingBalance: 0, income: 0, expense: 0, closingBalance: 0 }
  );

  const grandOpening  = catTotals.openingBalance + (commission?.openingBalance || 0);
  const grandIncome   = catTotals.income   + (commission?.income   || 0);
  const grandExpense  = catTotals.expense  + (commission?.expense  || 0);
  const grandClosing  = catTotals.closingBalance + (commission?.closingBalance || 0);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

      {/* Category rows */}
      <div className="card">
        <div className="card-header"><h3>Category Fund</h3></div>
        <FundTable
          rows={categories}
          tfoot={{ label: 'Total', ...catTotals }}
        />
      </div>

      {/* Commission card */}
      <div className="card">
        <div className="card-header"><h3>Commission Fund</h3></div>
        <FundTable
          rows={[{ category: 'Commission Income', openingBalance: commission?.openingBalance || 0, income: commission?.income || 0, expense: commission?.expense || 0, closingBalance: commission?.closingBalance || 0 }]}
          tfoot={{ label: 'Total', openingBalance: commission?.openingBalance || 0, income: commission?.income || 0, expense: commission?.expense || 0, closingBalance: commission?.closingBalance || 0 }}
        />
      </div>

      {/* Grand total */}
      <div className="card">
        <div className="card-header"><h3>Grand Total</h3></div>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th></th>
                <th className={styles.amtRight}>Opening (₹)</th>
                <th className={styles.amtRight}>Income (₹)</th>
                <th className={styles.amtRight}>Expense (₹)</th>
                <th className={styles.amtRight}>Closing Balance (₹)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Categories</td>
                <td className={styles.amtRight}>{fmtCurrency(catTotals.openingBalance)}</td>
                <td className={`${styles.amtRight} ${styles.balanceOk}`}>{fmtCurrency(catTotals.income)}</td>
                <td className={`${styles.amtRight} ${styles.balanceDiff}`}>{fmtCurrency(catTotals.expense)}</td>
                <td className={styles.amtRight}>{fmtCurrency(catTotals.closingBalance)}</td>
              </tr>
              <tr>
                <td>Commission</td>
                <td className={styles.amtRight}>{fmtCurrency(commission?.openingBalance || 0)}</td>
                <td className={`${styles.amtRight} ${styles.balanceOk}`}>{fmtCurrency(commission?.income || 0)}</td>
                <td className={`${styles.amtRight} ${styles.balanceDiff}`}>{fmtCurrency(commission?.expense || 0)}</td>
                <td className={styles.amtRight}>{fmtCurrency(commission?.closingBalance || 0)}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td><strong>Grand Total</strong></td>
                <td className={styles.amtRight}><strong>{fmtCurrency(grandOpening)}</strong></td>
                <td className={`${styles.amtRight} ${styles.balanceOk}`}><strong>{fmtCurrency(grandIncome)}</strong></td>
                <td className={`${styles.amtRight} ${styles.balanceDiff}`}><strong>{fmtCurrency(grandExpense)}</strong></td>
                <td className={styles.amtRight}><strong>{fmtCurrency(grandClosing)}</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

    </div>
  );
}
